module.exports = __webpack_public_path__ + "img/freewave2_banner.be66e126.jpg";